<template>
	<div class="form__group">
		<label class="form__label">Opportunity Type</label>
		<multiselect :options="options" v-model="selected" label="label" track-by="value" :show-labels="false">
		</multiselect>
        <a
            href="#"
            @click.prevent.stop="clearValue"
            class="form__clear"
            v-if="this.selected || (this.selected && this.selected.length > 0)"
        >
            Clear
        </a>
	</div>
</template>

<script>
	import ListFilter from './ListFilter';

	export default {
		name: 'ListFilterOpportunityType',
		mixins: [ListFilter],
		data() {
			return {
				options: [
					{
						label: 'Pitch Support Request',
						value: 1
					},
					{
						label: 'Live Origination Request',
						value: 2
					}
				]
			}
		},
        methods: {
            clearValue: function() {
                this.selected = this.multiple ? [] : null;
            }
        }
	}
</script>
